import React from "react";
import { Dialog, DialogProps } from "primereact/dialog";

export interface IBaseDialogProps extends DialogProps {
  children: React.ReactNode;
}

const baseClassName =
  "!overflow-hidden !rounded-2xl !p-0 [&_.p-dialog-header]:!border-none [&_.p-dialog-header]:!bg-transparent [&_.p-dialog-header]:!px-4 [&_.p-dialog-header]:!pt-4 [&_.p-dialog-header]:!pb-1 [&_.p-dialog-header]:!text-gray-900 [&_.p-dialog-content]:!bg-white";

const DialogBox = ({ visible, onHide, children, className, ...rest }: IBaseDialogProps) => {
  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      modal
      dismissableMask
      closable={false}
      draggable={false}
      resizable={false}
      position="center"
      blockScroll
      style={{ width: "auto" }}
      className={`${baseClassName} ${className ?? ""}`}
      maskClassName="!bg-black/30 "
      closeIcon
      {...rest}
    >
      {children}
    </Dialog>
  );
};

export default DialogBox;
